import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from '../../../shared/services/base.service';
import { SummaryGrantModel } from '../models/summary-grant.model';



@Injectable()
export class GrantService extends BaseService<SummaryGrantModel,SummaryGrantModel> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/grants');
  }

}
